import React, { useState, useEffect } from "react";
import Fade from "react-reveal/Fade";
import ReactPlayer from "react-player";
import parse from "html-react-parser";

import { ReactComponent as Icon1 } from "../../../assets/img/icons/ribbon.svg";
import { ReactComponent as Icon2 } from "../../../assets/img/icons/globe.svg";
import { ReactComponent as Icon3 } from "../../../assets/img/icons/map-store.svg";
import "./_weather-zone.scss";

const WeatherZones = ({ home: { home } }) => {
	const [isPlay, setIsPlay] = useState(false);
	useEffect(() => {
		setTimeout(() => {
			setIsPlay(true);
		}, 3000);
	}, []);
	return (
		<>
			{home && home.globe_section && (
				<div className="weather-zone-wrap">
					<div className="player-wrapper">
						<ReactPlayer
							playing={isPlay}
							muted={true}
							loop={true}
							url={home.globe_section.background_video}
							width="100%"
							height="100%"
						/>
					</div>
					<div className="container">
						<div className="content-box">
							<Fade bottom>
								<h2 className="h3">{home.globe_section.title}</h2>
							</Fade>
							<ul>
								<Fade bottom delay={200}>
									<li>
										<div className="icon">
											<Icon1 />
										</div>
										<div className="txt">
											{parse(home.globe_section.experience)}
										</div>
									</li>
								</Fade>
								<Fade bottom delay={300}>
									<li>
										<div className="icon">
											<Icon2 />
										</div>
										<div className="txt">
											{parse(home.globe_section.countries)}
										</div>
									</li>
								</Fade>
								<Fade bottom delay={400}>
									<li>
										<div className="icon">
											<Icon3 />
										</div>
										<div className="txt">
											{parse(home.globe_section.installations)}
										</div>
									</li>
								</Fade>
							</ul>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default WeatherZones;
